(function (angular) {
    'use strict';
    angular.module("dentist").controller('homeController', homeController);

    function homeController(dentistService, appointmentService, $location, $translate, $state, $scope, $timeout, $filter, $stateParams, $rootScope) {
        
        // backwards compatibility for dynamic profile changes. can be removed, once all the old, static profiles are switched
        var tempTreatmentId = getUrlParameter('treatmentId');
        if (tempTreatmentId && !$stateParams.treatmentId) {
            $stateParams.treatmentId = tempTreatmentId;
        }
        var tempPractitionerId = getUrlParameter('practitionerId');
        if (tempPractitionerId && !$stateParams.practitionerId) {
            $stateParams.practitionerId = tempPractitionerId;
        }
        var tempExpanded = getUrlParameter('expanded');
        if (tempExpanded && !$stateParams.expanded) {
            $stateParams.expanded = expanded;
        }
        var tempDate = getUrlParameter('date');
        if (tempDate && !$stateParams.date) {
            $stateParams.date = tempDate;
        }
        var tempScroll = getUrlParameter('scroll');
        if (tempScroll && !$stateParams.scroll) {
            $stateParams.scroll = tempScroll;
        }
        function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            };
        }
        ///////////////////////////
        
        
        //controller initialization
        var ctrl = this;
        ctrl.lastSlot = {
            startDate: '',
            endDate: ''
        };
        ctrl.changeLanguage = changeLanguage;

        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
            ctrl.currentSelectedLanguage = langKey;
            ctrl.setWeekDays();
            if (ctrl.parse != null)
                ctrl.GetPractionerTime(ctrl.parse);

            if (ctrl.Practitioners != null) {
                if (langKey == "de" && ctrl.Practitioners[0].id==0) {
                    ctrl.Practitioners[0].firstname = "Alle Praktizierenden";
                }
                else if (ctrl.Practitioners[0].id == 0) {
                    ctrl.Practitioners[0].firstname = "All practitioners";
                }

            }
            setWeekDays(true);
            changeServicesLanguage();
            GetAllAppointmentsOfPractitioner();

            //updateCalendar();
        }

        function changeServicesLanguage() {
            ctrl.Services = $.map(ctrl.Services, function (element, index) {
                element.priceCalculated = "";
                if (element.fixedPrice != null) {
                    element.priceCalculated += element.currency + ' ' + element.fixedPrice;
                }
                else if (element.minPrice != null && element.maxPrice == null) {
                    element.priceCalculated += $filter('translate')('from') + element.currency + ' ' + element.minPrice;
                }
                else if (element.minPrice == null && element.maxPrice != null) {
                    element.priceCalculated += $filter('translate')('to') + element.currency + ' ' + element.maxPrice;
                }
                else if (element.minPrice != null && element.maxPrice != null) {
                    element.priceCalculated += element.currency + ' ' + element.minPrice + ' - ' + element.maxPrice;
                }
                return element;
            });
        }

        function updateWeekDays(event, changeDate) {
            var nowdate = moment.utc();

            ctrl.days = [];
            var day = moment.utc(moment(changeDate, "DD.MM.YYYY").lang(ctrl.currentSelectedLanguage));
            var endOfWeek = moment.utc(moment(changeDate, "DD.MM.YYYY").lang(ctrl.currentSelectedLanguage)).add(ctrl.weekdays, 'd');
            // TODO [dom] set time of day (and endOfWeek) to noon, to avoid problems with UTC and local time being on different days
            while (day <= endOfWeek) {
                ctrl.days.push(day.toDate());
                day = day.clone().add(1, 'd');
            }

            //GetAllAppointmentsOfPractitioner();
            updateCalendar();
        }

        $scope.$on("UpdatingDate", updateWeekDays);

        ctrl.Checkwindow = Checkwindow;
        ctrl.isMobile = false;

        function Checkwindow() {
//            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        	if (window.screen.width < 768) {
                ctrl.isMobile = true;
                ctrl.weekdays = 2;
            }
            else {
                ctrl.isMobile = false;
                ctrl.weekdays = 6;
            }
        }
        ctrl.Checkwindow();
        //bindable objects
        ctrl.data = { practiceId: $stateParams.practiceId };  //===== Practice Id
        ctrl.Services = {};
        ctrl.freeTimesPerPractitioner = {};
        ctrl.RegSubmitted = false;
        // TODO move values into new, dedicated fields on the practice
        ctrl.earliestBookingTimes = {
            '200052': 48, // practice "Ort Hirzel"
            '200051': 48, // practice "Ort Bülach"
            '30675': 20, // practice "Diener"
            '31581': 24, // practice "Ruffo"
            '202229': 48 // practice "Smile&Co"
        };
        //bindable properties
        ctrl.isStandaloneBooking = $stateParams.standalone;
        if(ctrl.isStandaloneBooking) {
        	setTimeout(function () {
                ctrl.scrollTo($("#header"));
            }, 200);
        }
        ctrl.serviceCount = 4;
        ctrl.dentistCount = 4;
        ctrl.appointmentCount = 8; //ctrl.isMobile ? 2 : 4;
        ctrl.serviceSelected = false;
        ctrl.timeFromUrlParamWasSelected = false;
        ctrl.serviceName = "";
        ctrl.dentistName = "";
        ctrl.practiceBookingTerms = "";
        ctrl.setPrevWeek = setPrevWeek;
        ctrl.setNextWeek = setNextWeek;
        ctrl.practiceAddress = "";
        // bindable methods
        ctrl.getAllServicesAndPractitionersInPractice = getAllServicesAndPractitionersInPractice;
        ctrl.GetPractitionersOfService = GetPractitionersOfService;
        ctrl.GetAppointmentsOfPractitioner = GetAppointmentsOfPractitioner;
        ctrl.setPractitionerClass = setPractitionerClass;
        ctrl.SetPractioners = SetPractioners;
        ctrl.gotodetail = gotodetail;
        ctrl.selectTime = selectTime;
        ctrl.showCalendar = false;
        ctrl.GetPractionerTime = GetPractionerTime;
        ctrl.CheckItemDate = CheckItemDate;
        ctrl.findMaxAppointmentsAndPrevNextTime = findMaxAppointmentsAndPrevNextTime;
        ctrl.SetPractionerAllApointment = SetPractionerAllApointment;
        ctrl.GetAllAppointmentsOfPractitioner = GetAllAppointmentsOfPractitioner;
        ctrl.setWeekDays = setWeekDays;
        ctrl.setNextAppointment = setNextAppointment;
        ctrl.checkThisWeek = checkThisWeek;
        ctrl.isMentorBooking = isMentorBooking;
        ctrl.ecommerceObject = JSON.parse(localStorage.getItem("ecommerceObject"));
//        localStorage.removeItem("ecommerceObject");
        
        localStorage.setItem("lang", "de");
        ctrl.currentSelectedLanguage = localStorage.getItem("lang") ? localStorage.getItem("lang") : "de";

        init();
        ctrl.abcd = moment.utc().lang("de").toDate();

        function init() {
            if ($stateParams.filterPractitionerIds) {
                ctrl.filterPractitionerIds = $stateParams.filterPractitionerIds.split(',');
            }

            var serviceName = localStorage.getItem("serviceName");
            var history = localStorage.getItem("history");
            localStorage.setItem("history", "false"); // reload of the same page should yield new data
            if (localStorage.getItem("PractitionerSelectedFirst") == "true")
                ctrl.PractitionerSelectedFirst = true;
            else
                ctrl.PractitionerSelectedFirst = false;

            if (serviceName == null || history != "true") {
                localStorage.removeItem("selectedDate"); // reset possible stale value of selectedDate, which could influence shown days and queries for free appointments
                
                getAllServicesAndPractitionersInPractice(ctrl.data, ctrl.isStandaloneBooking); // get all services
                localStorage.setItem("customerdetail", "false"); // reset possible saved state of form values
            }
            else {
                ctrl.Serviceduration = localStorage.getItem("Serviceduration");
                ctrl.dentistName = localStorage.getItem("dentistName");
                ctrl.practiceName = localStorage.getItem("practiceName");
                updatePracticeName(ctrl.practiceName);
                ctrl.practiceBookingTerms = localStorage.getItem("practiceBookingTerms");
                ctrl.practiceCalendarType = localStorage.getItem("practiceCalendarType");
                ctrl.data.practitionerId = localStorage.getItem("practitionerId");
                ctrl.selectedPractitionID = ctrl.data.practitionerId;
                ctrl.selectedServiceOriginalId = localStorage.getItem("selectedServiceOriginalId");
                ctrl.selectedDate = moment(localStorage.getItem("selectedDate")).toDate();
                ctrl.selectedTime = localStorage.getItem("selectedTime");
                ctrl.serviceName = serviceName;
                ctrl.data.serviceId = localStorage.getItem("serviceID");
                ctrl.Services = JSON.parse(localStorage.getItem("selectedServices"));
                ctrl.Practitioners = JSON.parse(localStorage.getItem("selectedPractitioners"));
                ctrl.PractitionersAndService = JSON.parse(localStorage.getItem("PractitionersAndService"));
                ctrl.parse = JSON.parse(localStorage.getItem("selectedAppointments"));
                ctrl.AllServices = JSON.parse(localStorage.getItem("AllServices"));
                ctrl.AllPractioners = JSON.parse(localStorage.getItem("AllPractioners"));
                ctrl.selectedServiceObject = JSON.parse(localStorage.getItem("selectedServiceObject"));
                
                ctrl.showCalendar = true;
                ctrl.serviceSelected = true;
                ctrl.GetPractionerTime(ctrl.parse);
                var langKey = localStorage.getItem("lang");
                ctrl.currentSelectedLanguage = langKey;
                if (ctrl.Practitioners != null) {
                    if (langKey == "de")
                        ctrl.Practitioners[0].Name = "Alle Praktizierenden";
                    else
                        ctrl.Practitioners[0].Name = "All practitioners";
                }
                
                findIndexOfServiceAndIncreaseDisplayCountIfNecessary();
            }
            if (ctrl.isMobile === true) {
                $("#accordion").accordion("option", "active", 0);
            }
        }

        ctrl.Allapointment = {
            id: "0",
            firstname: "All practitioners",
            pictureUrl: "img/abc.png"
        };
        ctrl.GermanAllApointment = {
            id: "0",
            firstname: "Alle Praktizierenden",
            pictureUrl: "img/abc.png"
        };
        ctrl.DayNow = moment.utc().toDate();
        var startOfWeek = moment.utc();
        ctrl.startOfMonth = moment.utc().toDate();
        var endOfWeek = moment.utc().clone().add(ctrl.weekdays, 'd');
        var startOfTime = moment.utc().lang(ctrl.currentSelectedLanguage).format("DD MMM YYYY") + " " + "00:00:00";
        var endDate = moment.utc().lang(ctrl.currentSelectedLanguage).format("DD MMM YYYY") + " " + "23:59:59";
        var endOfTime = moment.utc(endDate, "DD MMM YYYY HH:mm:ss", ctrl.currentSelectedLanguage);
        var time = moment.utc(startOfTime, "DD MMM YYYY HH:mm:ss", ctrl.currentSelectedLanguage);
        
        function isMentorBooking() {
        	return ($stateParams.practiceId == 29852);
        }
        
        function showNotification(_message, _type) {

            switch (_type) {
                case 'success':
                    toastr.success(_message);
                    break;
                case 'error':
                    toastr.error(_message);
                    break;
                case 'warning':
                    toastr.warning(_message);
                    break;
            }
        }

        function scrollToTimeSelect() {
            $("#accordion").accordion("option", "active", 2);
            setTimeout(function () {
                ctrl.scrollTo($("#selectSlot"));
            }, 500);
        }

        function updatePracticeName(name) {
        	$('#practice-name').text(name);
        }

        function findPractionerById(id) {
            return ctrl.AllPractioners.find(function(p) { return p.id == id });
        }

        function findServiceById(id) {
        	return ctrl.AllServices.find(function(s) { return s.ID_Service == id });
        }

        function setWeekDays(loadFromStorage) {
            ctrl.days = [];
            var day = moment.utc();
            var startDay = localStorage.getItem("selectedDate");
            if (loadFromStorage == true && startDay != "undefined" && startDay != null && startDay != "Invalid date" && startDay != "invalid date") {
                day = moment(startDay);
            }
            // TODO [dom] set time of day to noon, to avoid problems with UTC and local time being on different days
            var endWeek = moment.utc(day).clone().add(ctrl.weekdays, 'd');//moment.utc(day).clone().add(ctrl.weekdays, 'd');
            while (day <= endWeek) {
                ctrl.days.push(day.toDate());
                day = day.clone().add(1, 'd');
            }
            //GetAllAppointmentsOfPractitioner();
            updateCalendar();
        }
//        ctrl.days = [];
//        var day = startOfWeek;

//        while (day <= endOfWeek) {
            //ctrl.days.push(day.toDate());
//            day = day.clone().add(1, 'd');
//        }
        //console.log(ctrl.time);

        function findOriginalServiceId() {
        	var selectedPractitioner = findPractionerById(ctrl.selectedPractitionID);
        	var originalIdsOfSelectedService = findServiceById(ctrl.data.serviceId).originalIds;

        	for (var i = 0; i < originalIdsOfSelectedService.length; i++) {
                var id = originalIdsOfSelectedService[i];
                // FIXME fix appointment change: treatmentIds are null??
                if (selectedPractitioner.treatmentIds.indexOf(id) >= 0) {
                	return id;
                }
        	}
        }

        function selectTime(time, date) {

            ctrl.selectedPractitionID = time.practitionerIds.toString().split(',')[0];
            var dentist = findPractionerById(ctrl.selectedPractitionID);
            ctrl.dentistName = (dentist.title ? dentist.title + ' ' : '') + dentist.firstname + ' ' + dentist.lastname;
            localStorage.setItem("selectedActualPractitionerId", dentist.id);

            ctrl.selectedTime = time.time;
            ctrl.selectedDate = moment.utc(date).toDate();
            localStorage.setItem("selectedDate", ctrl.selectedDate);
            localStorage.setItem("selectedTime", ctrl.selectedTime);
            if (ctrl.isMobile === true) {
                $("#accordion").accordion("option", "active", "false");
//                ctrl.scrollTo("#appointment");
            }
            
            ctrl.selectedServiceOriginalId = findOriginalServiceId();
            localStorage.setItem("selectedServiceOriginalId", ctrl.selectedServiceOriginalId);
        }

        function setNextWeek() {
            var Language = localStorage.getItem("lang");
            var startday = moment.utc(ctrl.days[0], "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).clone().add(ctrl.weekdays + 1, 'd');

            //localStorage.setItem("selectedDate", startday);

            var endday = moment.utc(ctrl.days[ctrl.weekdays], "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).clone().add(ctrl.weekdays + 1, 'd');
            ctrl.days = [];
            while (startday <= endday) {
                if (Language == "de")
                    ctrl.days.push(startday.toDate()); //lang("de").format("dddd MM/DD/YYYY"));
                else
                    ctrl.days.push(startday.toDate()); //lang("en").format("dddd MM/DD/YYYY"));
                startday = startday.add(1, 'd');
            }
            
            if (ctrl.lastSlot.startDate != "" && moment.utc(endday) > moment.utc(ctrl.lastSlot.endDate)) {
               GetAllAppointmentsOfPractitioner();
            } else {
            	updateCalendar();
            }
            //GetAllAppointmentsOfPractitioner();
        }
        ctrl.setTime = [];

        ctrl.currentDays = [];
        ctrl.mostAppointmentsPerDay = 0;
        function updateCalendar() {
            ctrl.currentDays = [];
            ctrl.noAppointment = true;
			if(ctrl.days){
			    $.each(ctrl.days, function (index, item) {
			        var timings = CheckItemDate(item, ctrl.time);

				    timings = timings.sort(function (aTime, bTime) {
				        var a = moment.utc(aTime.time, "H:mm");
				        var b = moment.utc(bTime.time, "H:mm");
				        return a.isAfter(b) ? 1 : (a.isBefore(b) ? -1 : 0);
				    });
					if (timings.length > 0) {
						ctrl.noAppointment = false;
					}
					var dayObject = {
						dayDate: item,
						timings: timings
					};
					ctrl.currentDays.push(dayObject);
			    });
			    ctrl.mostAppointmentsPerDay = findMaxAppointmentsAndPrevNextTime(ctrl.days);
			    
			    $timeout(function () {
			        $scope.$apply();
			    });
			}
        }

        function CheckItemDate(item, t) {
        	var result = [];
        	function isAdded(currentTime, practitionerIds) {
        		for (var i=0; i<result.length; i++) {
        			if (result[i].time == currentTime && result[i].practitionerIds == practitionerIds) {
        				return true;
        			}
        		}
        		return false;
        	}

        	var itemDay = moment(item).format("DD.MM.YYYY");
            if (ctrl.selectedPractitionID == null) {
                return result;
            }
            if (t != null) {
                for (var i = 0; i < t.length; i++) {
                	var currentTimeMoment = t[i].time.clone();
                    if (itemDay == currentTimeMoment.local().format("DD.MM.YYYY")) {
                        if (isAdded(currentTimeMoment.local().format("H:mm"), t[i].practitionerIds) != true) {
                            result.push({ time: currentTimeMoment.local().format("H:mm"), practitionerIds: t[i].practitionerIds });
                        }
                        else {
                           // console.log('duplicate: ' + { time: moment.utc(t[i].time).format("hh:mm a"), practitionerIds: t[i].practitionerIds });
                        }
                    }
                }
            }

            return result;
        }

        function setNextAppointment(date) {
            ctrl.days = [];
            var day = moment.utc(date, "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage);
            //localStorage.setItem("selectedDate", day);
            var endOfWeek = moment.utc(date, "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).add(ctrl.weekdays, 'd');
            // TODO [dom] set time of day (and endOfWeek) to noon, to avoid problems with UTC and local time being on different days
            while (day <= endOfWeek) {

                ctrl.days.push(day.toDate());
                day = day.clone().add(1, 'd');
            }
            $timeout(function () {
                $scope.$apply();
            });
            GetAllAppointmentsOfPractitioner();
            //updateCalendar();
        }
        ctrl.noAppointment = false;

        function findMaxAppointmentsAndPrevNextTime(days) {
        	ctrl.nextTime = [];
        	ctrl.prevTime = [];
            if (ctrl.time == null || ctrl.time.length==0 ) {
                return 0;
            }
            var result = ctrl.days.length;
            var maxCount = 0;
            if (ctrl.time != null) {
                ctrl.time = ctrl.time.sort(function (a, b) {
                    return a.time.isAfter(b.time) ? 1 : (a.time.isBefore(b.time) ? -1 : 0);
                });

            	var currentMoment = moment.utc();
                for (var item = 0; item < ctrl.days.length; item++) {
                	var dayMoment = moment(ctrl.days[item]); // date of ctrl.days needs to be interpreted as local, as time might be midnight and thus UTC on another date
                    var daysCount = $.map(ctrl.time, function (obj, index) {
                    	var timeMoment = obj.time.clone();
                        if (dayMoment.format("DD.MM.YYYY") == timeMoment.format("DD.MM.YYYY")) {
                            return obj;
                        }
                        else {
                            if (dayMoment.isBefore(timeMoment)) {
                                ctrl.nextTime.push(ctrl.time[index]);
                            }
                            if (dayMoment.isAfter(timeMoment) && currentMoment.isSameOrBefore(timeMoment)) {
                                ctrl.prevTime.push(ctrl.time[index]);
                            }
                        }
                    });

                    if (daysCount.length > maxCount)
                        maxCount = daysCount.length;

                }
            }

            return maxCount;
        }

        function setPrevWeek() {
            var lastStartDate = ctrl.weekdays;
            var Language = localStorage.getItem("lang");
            // FIXME [dom] WTF???
            //localStorage.setItem("selectedDate", startday);

            if (moment.utc().lang(ctrl.currentSelectedLanguage).format("DD MMM YYYY") != moment.utc(ctrl.days[0], "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).lang(ctrl.currentSelectedLanguage).format("DD MMM YYYY")) {
                var startday = moment.utc(ctrl.days[0], "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).subtract(ctrl.weekdays + 1, 'd');

                var endday = moment.utc(ctrl.days[ctrl.weekdays], "dddd MM/DD/YYYY", ctrl.currentSelectedLanguage).subtract(ctrl.weekdays + 1, 'd');
                ctrl.days = [];
                while (startday <= endday) {
                    if (Language == "de")
                        ctrl.days.push(startday.toDate()); // lang("de").format("dddd MM/DD/YYYY"));
                    else
                        ctrl.days.push(startday.toDate()); // lang("en").format("dddd MM/DD/YYYY"));

                    startday = startday.add(1, 'd');
                }

                updateCalendar();
            }

        }

        function handleSpecialTreatmentCases(treat) {
            if (ctrl.data.practiceId != 30682) { // currently only special handling for swiss smile
                return;
            }
            
            if (treat.originalIds.indexOf(34027) >= 0) { // swiss smile Kontrolle und Dentalhygiene
                treat.type = treat.type + '_PA';
            }
            if (treat.originalIds.indexOf(34026) >= 0) { // swiss smile Dentalhygiene
                treat.type = treat.type + '_DH';
            }
        }
        
        function getAllServicesAndPractitionersInPractice(practiceId, standalone) {
            uiBlock();

            dentistService.getAllServicesAndPractitionersInPractice(practiceId, standalone).then(function (res) {
                uiUnBlock();
                var result = res.data;
                
                ctrl.practiceAddress = result.addressStreet + (result.addressStreetNumber ? " " + result.addressStreetNumber : '')  + ", " + result.addressPostalCode + " " + result.addressCity;
                
                ctrl.practiceName = result.name;
                updatePracticeName(ctrl.practiceName);
                if (ctrl.isStandaloneBooking) {
                    $rootScope.standaloneStyle = result.standaloneStyle;
                }
                ctrl.practiceBookingTerms = result.bookingTerms;
                ctrl.practiceCalendarType = result.calendarType;
                if (ctrl.isStandaloneBooking && result.standaloneStyle && $stateParams.style && result.standaloneStyle.indexOf("." + $stateParams.style) >= 0) { // we only want to set an externally provided class, that is defined in standaloneStyle
                    $rootScope.bookingStyle = $stateParams.style;
                }

                ctrl.PractitionersAndService = result.groupedTreatments;
                ctrl.PractitionersAndService = filterAndUpdateTreatmentsByPractitionersUrlParam(ctrl.PractitionersAndService);
                ctrl.Services = $.map(ctrl.PractitionersAndService, function (element, index) {
                    element.ID_Service = index + 1;
                    element.noTimeSlotsAvailable = false;
                    element.priceCalculated = "";
                    
                    handleSpecialTreatmentCases(element);
                    
                    if (element.fixedPrice != null) {
                        element.priceCalculated += $filter('currency')(element.fixedPrice);
                    }
                    else if (element.minPrice != null && element.maxPrice == null) {
                        element.priceCalculated += $filter('translate')('from') + $filter('currency')(element.minPrice);
                    }
                    else if (element.minPrice == null && element.maxPrice != null) {
                        element.priceCalculated += $filter('translate')('to') + $filter('currency')(element.maxPrice);
                    }
                    else if (element.minPrice != null && element.maxPrice != null) {
                        element.priceCalculated +=  element.currency + ' '+element.minPrice + ' - ' + element.maxPrice;
                    }
                    return element;
                });

                ctrl.Practitioners = result.practitioners;
                ctrl.Practitioners = filterPractitionersByUrlParam(ctrl.Practitioners);

                var lang = localStorage.getItem("lang");
                if (lang == "de")
                    ctrl.Practitioners.push(ctrl.GermanAllApointment);
                else
                    ctrl.Practitioners.push(ctrl.Allapointment);
                $.map(ctrl.Practitioners, function (element, index) {
                    if (element.id == "0") {

                        ctrl.Practitioners.splice(0, 0, element);
                        ctrl.Practitioners.splice(index + 1, 1);
                    }
                });
                ctrl.AllPractioners = ctrl.Practitioners;
                ctrl.AllServices = ctrl.Services;
                updateCalendar();
                
                // handle case of existing url param. should be refactored into separate method.
                var treatmentIdStateParam = $stateParams.treatmentId;
                if ($stateParams.practitionerId && !treatmentIdStateParam) {
                    var practitionerIdNumber = Number($stateParams.practitionerId);
                    var service = ctrl.Services.find(function (element) { return element.practitionerIds.indexOf(practitionerIdNumber) !== -1; });
                    if (service) {
                        treatmentIdStateParam = service.originalIds[0];
                    }
                }
                if (treatmentIdStateParam) {
                    var treatmentId = Number(treatmentIdStateParam);
                    var service = ctrl.Services.find(function (element) { return element.originalIds.indexOf(treatmentId) !== -1; });
                    ctrl.GetPractitionersOfService(service);
                    
                    findIndexOfServiceAndIncreaseDisplayCountIfNecessary();
                }
                

                // for performance reasons, currently treatment status only updated for local calendars
                if (!result.useExternalCalendar) {
                	GetAllAppointmentsOfTreatments();
            	} else { // scrolling at a late stage would normally happen in the processing of GetAllAppointmentsOfTreatments, therefore we need to bring it forward in this case
            	    scrollPageAtALateStage();
            	}

            }, function (error) {

            });

        }

        function filterAndUpdateTreatmentsByPractitionersUrlParam(treatments) {
            if (ctrl.filterPractitionerIds) {
                treatments.forEach(function(treat) {
                    treat.practitionerIds = treat.practitionerIds.filter(function(id) { return ctrl.filterPractitionerIds.indexOf(id.toString()) !== -1; });
                });
                return treatments.filter(function(treat) { return treat.practitionerIds.length > 0; });
            } else {
                return treatments;
            }
        }

        function filterPractitionersByUrlParam(practitioners) {
            if (ctrl.filterPractitionerIds) {
                return practitioners.filter(function(pract) { return ctrl.filterPractitionerIds.indexOf(pract.id.toString()) !== -1; });
            } else {
                return practitioners;
            }
        }

        function findIndexOfServiceAndIncreaseDisplayCountIfNecessary() {
        	var index = $filter('orderBy')(ctrl.Services, 'noTimeSlotsAvailable')
        				.findIndex(function (element) {
        					return element.ID_Service == ctrl.data.serviceId; 
        				});
        	
        	index = index + 1;
        	if (index>4) {
        		var times = index/4+1;
        		ctrl.serviceCount = times*ctrl.serviceCount;
        	}
        }

        function gotodetail() {
            localStorage.setItem("selectedServices", JSON.stringify(ctrl.Services));
            localStorage.setItem("selectedPractitioners", JSON.stringify(ctrl.Practitioners));
            localStorage.setItem("selectedAppointments", JSON.stringify(ctrl.parse));
            localStorage.setItem("Serviceduration", ctrl.Serviceduration);
            localStorage.setItem("PractitionersAndService", JSON.stringify(ctrl.PractitionersAndService));
            localStorage.setItem("PractitionerSelectedFirst", ctrl.PractitionerSelectedFirst);
            localStorage.setItem("dentistName", ctrl.dentistName);
            localStorage.setItem("practiceName", ctrl.practiceName);
            localStorage.setItem("practiceId", ctrl.data.practiceId);
            localStorage.setItem("practiceBookingTerms", ctrl.practiceBookingTerms);
            localStorage.setItem("practiceCalendarType", ctrl.practiceCalendarType);
            localStorage.setItem("serviceName", ctrl.serviceName);
            localStorage.setItem("selectedTime", ctrl.selectedTime);
            localStorage.setItem("practitionerId", ctrl.data.practitionerId);
            localStorage.setItem("AllPractioners", JSON.stringify(ctrl.AllPractioners));
            localStorage.setItem("AllServices", JSON.stringify(ctrl.AllServices));
            localStorage.setItem("serviceID", ctrl.data.serviceId);
            localStorage.setItem("selectedServiceOriginalId", ctrl.selectedServiceOriginalId);
            
            localStorage.setItem("practiceAddress", ctrl.practiceAddress);
            
            var dentist = findPractionerById(ctrl.selectedPractitionID);
            localStorage.setItem("selectedActualPractitionerId", dentist.id);
            
            ctrl.selectedServiceOriginalId = findOriginalServiceId();
            localStorage.setItem("selectedServiceOriginalId", ctrl.selectedServiceOriginalId);
            localStorage.setItem("selectedDate", ctrl.selectedDate);
            localStorage.setItem("selectedServiceObject", JSON.stringify(ctrl.selectedServiceObject));

            checkoutTreatmentGA();

			var gtmDataLayer = window.dataLayer || [];
			gtmDataLayer.push({
				'event' : 'formView'
			});

            $state.go("detail", {ecommerceObject: ctrl.ecommerceObject});

        }
        
        function buildSelectedDateTime() {
            var hourAndMinute = ctrl.selectedTime.split(':');
            var selectedDateTime = moment(ctrl.selectedDate);
            selectedDateTime.hours(hourAndMinute[0]);
            selectedDateTime.minutes(hourAndMinute[1]);
            selectedDateTime.seconds(0);
            return selectedDateTime;
        }

        function checkoutTreatmentGA() {
            var time = moment(buildSelectedDateTime());
            
            var variant;
            
            if(time.isBefore(moment().add(1, 'days'))) {
                variant = "24h";
            } else if(time.isBefore(moment().add(2, 'days'))) {
                variant = "24h-48h";
            } else if(time.isBefore(moment().add(7, 'days'))) {
                variant = "2d-1week";
            } else if(time.isBefore(moment().add(14, 'days'))) {
                variant = "1week-2weeks";
            } else if(time.isBefore(moment().add(1, 'months'))) {
                variant = "2weeks-1month";
            } else if(time.isBefore(moment().add(2, 'months'))) {
                variant = "1month-2months";
            } else if(time.isBefore(moment().add(6, 'months'))) {
                variant = "2months-6months";
            } else if(time.isBefore(moment().add(12, 'months'))) {
                variant = "1year";
            } else {
                variant = "over1year";
            }
            
            var data = {
            		'ecommerce': {
            			'checkout': {
            				'actionField': {
                                'affiliation': (ctrl.isStandaloneBooking ? "standalone" : "platform"),
                                'list': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.actionField.list != null ? ctrl.ecommerceObject.ecommerce.click.actionField.list : null,
            					'step': '1'
            				},
            				'products': [{
            					'name': String(ctrl.serviceName),
            					'brand': String(ctrl.practiceName),
            					'coupon': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.products[0].coupon != null ? ctrl.ecommerceObject.ecommerce.click.products[0].coupon : null, // FIXME replace with actual coupon from ctrl.selectedServiceObject
            					'position': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.products[0].position != null ? ctrl.ecommerceObject.ecommerce.click.products[0].position : null,
            					'variant': String(variant),
            					'quantity': '1',
            				}]
            			}
            		}
            };

        	var item = JSON.parse(localStorage.getItem("selectedServiceObject"));
        	if (item.fixedPrice) {
        		data.ecommerce.checkout.products[0].price = Number(item.fixedPrice); 
        	}

        	var dataLayer = window.dataLayer || [];       	
        	dataLayer.push(data);
        }

        function GetPractionerTime(parse) {
            var Language = localStorage.getItem("lang");

            ctrl.parsedates = parse;
            ctrl.time = [];

            function getIndex(startTime, language) {
                for (var i = 0; i < ctrl.time.length; i++) {
                    if (ctrl.time[i].time.isSame(startTime)) {
                        return i;
                    }
                }
                return -1;
            }

            var earliestBookingTime = getEarliestBookingTime();

            for (var i = 0; i < parse.length; i++) {
                var startTimes = moment.utc(parse[i].startTime);
                var endTimeMoment = moment.utc(parse[i].endTime);
                var practitionerIds = parse[i].practitionerIds.toString();

                if (ctrl.Serviceduration == null)
                    practitionerIds = '';
                while (ctrl.Serviceduration!=null && startTimes.clone().add(ctrl.Serviceduration, 'm').isSameOrBefore(endTimeMoment)) {
                    if (startTimes.isAfter(earliestBookingTime)) {
                        if (Language == "de") {
                            var indexOfExistingTime = getIndex(startTimes, "de");// ctrl.time.indexOf(startTimes)
                            if (indexOfExistingTime >= 0) {
                                ctrl.time[indexOfExistingTime].practitionerIds += "," + practitionerIds;
                            }
                            else {
                                ctrl.time.push({ ID_Service: ctrl.data.serviceId, time: startTimes, practitionerIds: practitionerIds });
                            }
                        }
                        else {
                            var indexOfExistingTimeEn = getIndex(startTimes, "en");//ctrl.time.indexOf(startTimes)
                            if (indexOfExistingTimeEn >= 0) {
                                ctrl.time[indexOfExistingTimeEn].practitionerIds += "," + practitionerIds;
                            }
                            else {
                                ctrl.time.push({ ID_Service: ctrl.data.serviceId, time: startTimes, practitionerIds: practitionerIds });
                            }
                        }
                    }
                    startTimes = startTimes.clone().add(ctrl.Serviceduration, 'm');
                }

            }
            //updateCalendar();
        }

        function getEarliestBookingTime() {
            var minimumHoursBetweenNowAndBookableAppointment = ctrl.earliestBookingTimes[ctrl.data.practiceId] ?
                                                                  ctrl.earliestBookingTimes[ctrl.data.practiceId] : 2;
            return moment.utc().add(minimumHoursBetweenNowAndBookableAppointment, 'hours');
        }

        ctrl.scrollTo = function (id) {
            $('html, body').animate({
                scrollTop: $(id).offset().top-50
            }, 1000);
        };

        function GetPractitionersOfService(item) {
            ctrl.nextTime = [];
            ctrl.prevTime = [];
            ctrl.time = [];
            ctrl.firstServiceOfPractitioner = null;

            if ((ctrl.data.serviceId == item.ID_Service) && !ctrl.isStandaloneBooking) {
                if (ctrl.PractitionerSelectedFirst == false) {

                    ctrl.dentistName = null;
                    ctrl.serviceName = null;
                    ctrl.data.practitionerId = null;
                    ctrl.data.serviceId = null;
                    var language = localStorage.getItem("lang");
                    localStorage.clear();
                    localStorage.setItem("lang", language);
                    ctrl.Practitioners = ctrl.AllPractioners;
                    ctrl.Services = ctrl.AllServices;
                    ctrl.showCalendar = false;
                    ctrl.PractitionerSelectedFirst = false;
                    ctrl.selectedDate = null;
                    ctrl.selectedTime = null;
                    ctrl.selectedPractitionID = null;
                }
            }
            else {
                if (ctrl.isMobile === true) {
                    /* $("#accordion").accordion("option", "active", 1);
                    setTimeout(function () {
                        ctrl.scrollTo($(".practitioner_inner.activated").last());
                    }, 500); */
                    scrollToTimeSelect();
                }
                if (ctrl.PractitionerSelectedFirst == true) {

                    ctrl.PractitionerSelectedFirst = false;
                    ctrl.selectedFirst = false;
                    ctrl.serviceSelected = true;
                    ctrl.data.serviceId = item.ID_Service;
                    ctrl.dentistName = null;
                    ctrl.data.practitionerId = null;
                    ctrl.selectedDate = null;
                    ctrl.selectedTime = null;
                    ctrl.SetPractioners(item);
                }
                else {
                    ctrl.selectedFirst = false;
                    ctrl.serviceSelected = true;
                    ctrl.data.serviceId = item.ID_Service;
                    ctrl.dentistName = null;
                    ctrl.data.practitionerId = null;
                    ctrl.selectedDate = null;
                    ctrl.selectedTime = null;
                    ctrl.SetPractioners(item);
                }
            }
        }

        function SetPractioners(item) {
            ctrl.Practitionerss = [];

            $.each(ctrl.AllPractioners, function (index, practitioner) {
                if (item.practitionerIds.find(function(id) { return practitioner.id === id } ) != null) {
                    ctrl.Practitionerss.push(practitioner);
                }
            });
            //end

            ctrl.PractitionersService = [];
            if (ctrl.Practitionerss.length == 1) {
                ctrl.dentistName = (ctrl.Practitionerss[0].title ? ctrl.Practitionerss[0].title + ' ' : '' ) + ctrl.Practitionerss[0].firstname + ' ' + ctrl.Practitionerss[0].lastname;
                ctrl.data.practitionerId = ctrl.Practitionerss[0].id;
                ctrl.selectedPractitionID = ctrl.Practitionerss[0].id;
                ctrl.Practitioners = ctrl.Practitionerss;
                ctrl.selectedFirst = true;
                localStorage.setItem("dentistName", ctrl.dentistName);
                localStorage.setItem("practitionerId", ctrl.data.practitionerId);
                ctrl.GetAllAppointmentsOfPractitioner();
            }
            else {
                ctrl.Serviceduration = item.duration;

                var lang = localStorage.getItem("lang");
                if (lang == "de")
                    ctrl.Practitionerss.push(ctrl.GermanAllApointment);
                else
                    ctrl.Practitionerss.push(ctrl.Allapointment);
                ctrl.SetPractionerAllApointment();
            }
            //updateCalendar();

            ctrl.serviceName = item.type;
            
            ctrl.Serviceduration = item.duration;

            ctrl.selectedServiceObject = item;
            
            localStorage.setItem("selectedServiceObject", JSON.stringify(item));
            localStorage.setItem("serviceName", ctrl.serviceName);
            localStorage.setItem("serviceID", item.ID_Service);
        }

        function SetPractionerAllApointment() {
            uiBlock();
            
            if (ctrl.Practitioners != null) {

                // handle case of existing url param. should be refactored into separate method and should use own ...WasSelected-switch.
                if ($stateParams.practitionerId && !ctrl.timeFromUrlParamWasSelected) {
                    ctrl.selectedPractitionID = Number($stateParams.practitionerId);

                    // we want this to happen only once
                    // FIXME [dom] save this param to localStorage, so that it can be used when getting back here from the form
                    ctrl.timeFromUrlParamWasSelected = true;
                }

                $.map(ctrl.Practitionerss, function (element, index) {
                    if (ctrl.selectedPractitionID == element.id) {
                        ctrl.dentistName = (element.title ? element.title + ' ' : '') + element.firstname + (element.lastname != null ? ' ' + element.lastname : '');
                        ctrl.data.practitionerId = element.id;
                        ctrl.selectedPractitionID = element.id;
                        ctrl.selectedFirst = true;

                        ctrl.Practitionerss.splice(0, 0, element);

                        ctrl.Practitionerss.splice(index + 1, 1);
                    }

                });

                if (ctrl.selectedFirst == false) {
                    $.map(ctrl.Practitionerss, function (element, index) {
                        if (element.id == "0") {
                            ctrl.dentistName = element.firstname;
                            ctrl.data.practitionerId = element.id;
                            ctrl.selectedPractitionID = element.id;
                            ctrl.Practitionerss.splice(0, 0, element);
                            ctrl.Practitionerss.splice(index + 1, 1);
                        }
                    });
                }
                uiUnBlock();
                $.map(ctrl.Practitionerss, function (element, index) {
                    if (element.id == "0") {

                        ctrl.Practitionerss.splice(0, 0, element);
                        ctrl.Practitionerss.splice(index + 1, 1);
                    }
                });
                ctrl.Practitioners = ctrl.Practitionerss;
                localStorage.setItem("dentistName", ctrl.dentistName);
                localStorage.setItem("practitionerId", ctrl.data.practitionerId);
                GetAllAppointmentsOfPractitioner();
            } else {
            	updateCalendar();
            }
        }

        function setPractitionerClass(item) {
            //|| ctrl.firstServiceOfPractitioner != null
            if (ctrl.PractitionerSelectedFirst == true) {
                var check = ctrl.PractitionersAndService.findIndex( function(c) { return c.practitionerIds.indexOf(ctrl.data.practitionerId) != -1 && c.ID_Service == item.ID_Service } );

                if (check == -1 && ctrl.data.practitionerId != "0") {
                    return "grayout";
                }
            }
        }

        // ctrl.PractitionerSelectedFirst = false;
        function GetAppointmentsOfPractitioner(id, practitioner) {
        	var name = (practitioner.title ? practitioner.title + ' ' : '') + practitioner.firstname + (practitioner.lastname ? ' ' + practitioner.lastname : '');
            if (ctrl.data.serviceId == null) {
                ctrl.nextTime = [];
                ctrl.prevTime = [];
                ctrl.time = [];
                if (ctrl.data.practitionerId == id) {
                    ctrl.dentistName = null;
                    ctrl.serviceName = null;
                    ctrl.data.practitionerId = null;
                    ctrl.data.serviceId = null;
                    ctrl.selectedPractitionID = null;
                    var language = localStorage.getItem("lang");
                    localStorage.clear();
                    localStorage.setItem("lang", language);
                    ctrl.showCalendar = false;
                    ctrl.PractitionerSelectedFirst = false;
                }
                else {
                    if (ctrl.isMobile === true) {
                    	$("#accordion").accordion("option", "active", 0);
                        setTimeout(function () {
                            ctrl.scrollTo($(".services_inner"));
                        }, 500);
                    }
                    ctrl.PractitionerSelectedFirst = true;
                    var services = ctrl.Services;
                    ctrl.Services = [];
                    ctrl.Services = services;
                    ctrl.data.practitionerId = id;
                    ctrl.selectedPractitionID = id;
                    ctrl.dentistName = name;
                }
            }
            else {
                if (ctrl.data.practitionerId == id && ctrl.PractitionerSelectedFirst == true) {
                    ctrl.dentistName = null;
                    ctrl.serviceName = null;
                    ctrl.data.practitionerId = null;
                    ctrl.data.serviceId = null;
                    ctrl.selectedDate = null;           
                    ctrl.selectedTime = null;
                    ctrl.selectedPractitionID = null;
                    var language = localStorage.getItem("lang");
                    localStorage.clear();
                    localStorage.setItem("lang", language);
                    ctrl.showCalendar = false;
                    ctrl.PractitionerSelectedFirst = false;
                }
                else {
                    if (ctrl.PractitionerSelectedFirst == true) {
                        ctrl.PractitionerSelectedFirst = true;
                        var services = ctrl.Services;
                        ctrl.Services = [];
                        ctrl.Services = services;
                        ctrl.data.practitionerId = id;
                        ctrl.selectedPractitionID = id;
                        ctrl.dentistName = name;
                        ctrl.serviceName = null;
                        ctrl.data.serviceId = null;
                    }
                    else {
                        if (ctrl.isMobile === true) {
                            scrollToTimeSelect();
                        }
                        ctrl.serviceSelected = true;
                        ctrl.data.practitionerId = id;
                        ctrl.selectedPractitionID = id;
                        ctrl.dentistName = name;
                        ctrl.selectedDate = null;
                        localStorage.setItem("dentistName", ctrl.dentistName);
                        localStorage.setItem("practitionerId", ctrl.data.practitionerId);
                        ctrl.GetAllAppointmentsOfPractitioner();
                    }
                }
            }
        }

        function checkdays() {

        }

        function GetAllAppointmentsOfPractitioner() {
            
            ctrl.appointmentCount = 8;

            var practitionarIDs = null;
            if (ctrl.selectedPractitionID == 0) {
                practitionarIDs = $.map(ctrl.Practitioners, function (obj, i) {
                    return obj.id;
                }).join(',');
            }
            else {
                practitionarIDs = ctrl.selectedPractitionID;
            }
            if (practitionarIDs == null) {
                ctrl.nextTime = [];
                ctrl.prevTime = [];
                ctrl.currentDays.timings = [];
                ctrl.time = [];
                return;
            }
            uiBlock();

            var startDate = moment.utc().lang(ctrl.currentSelectedLanguage).format("YYYY-MM-DD");//moment.utc(ctrl.days[0]).format("YYYY-MM-DD");
            var endDate = moment.utc(ctrl.days[ctrl.days.length - 1], "MM/DD/YYYY", ctrl.currentSelectedLanguage).add(3, 'months').format("YYYY-MM-DD");

            ctrl.lastSlot.startDate = moment.utc(startDate, "YYYY-MM-DD").lang(ctrl.currentSelectedLanguage);
            ctrl.lastSlot.endDate = moment.utc(endDate, "YYYY-MM-DD").lang(ctrl.currentSelectedLanguage);
            
//            practitionarIDs.split(",").forEach(function (pId) {
//            	loadAllAppointmentsOfPractitioner(ctrl.data, pId, startDate, endDate, function (result) {
            appointmentService.getAllAppointmentsOfPractitioner(ctrl.data, practitionarIDs, startDate, endDate).then(function (res) {
                var result = res.data;

                ctrl.parse = result;//JSON.parse(result.appointments);

                try {
	                if (ctrl.parse.length > 0) {
	                    ctrl.noAppointment = false;
	                    ctrl.GetPractionerTime(ctrl.parse);
	                }
	                else {
	
	                    ctrl.noAppointment = true;
	                    ctrl.time = [];
	                    var selected = ctrl.selectedPractitionID;
	                    if (ctrl.selectedPractitionID == 0 && ctrl.Practitioners.length>1) {
	                        selected = ctrl.Practitioners[1].id;
	                    }
	
	                    var matchPractionerAndService = function (obj) {
	                        return (obj.practitionerIds == selected &&
	                                obj.ID_Service == ctrl.data.serviceId);
	                    };
	
	                    ctrl.nextTime = ctrl.nextTime.filter(matchPractionerAndService);
	                    ctrl.prevTime = ctrl.prevTime.filter(matchPractionerAndService);
	                }
	                updateCalendar();
	                
	                if (ctrl.mostAppointmentsPerDay == 0 && ctrl.nextTime.length != 0) {
	                	ctrl.setNextAppointment(ctrl.nextTime[0].time);
			    	}
	
	                //ctrl.GetPractionerTime(ctrl.parse);
	                if (!ctrl.showCalendar) {
	                    ctrl.showCalendar = true;
	                }
	
	                // handle case of existing url param. should be refactored into separate method (and put in a separate then.()-block?)
	                
	                if ($stateParams.date && !ctrl.timeFromUrlParamWasSelected) {
	                    var queryParamMoment = moment($stateParams.date);
	                    var queryParamTime = queryParamMoment.format("H:mm");
	
	                    // TODO [dom] optimize: this updates the calendar again (updateCalendar). could be avoided
	                    updateWeekDays(null, queryParamMoment.format("DD.MM.YYYY"));
	                    var dayItem = ctrl.currentDays.find(function (element) { return queryParamMoment.isSame(element.dayDate, 'day'); });
	                    var timeItem = dayItem.timings.find(function (element) { return queryParamTime === element.time; });
	                    
	                    if (timeItem) {
	                        ctrl.selectTime(timeItem, dayItem.dayDate);
	                    }
	                    
	                    // we want this to happen only once
	                    // FIXME [dom] save this param to localStorage, so that it can be used when getting back here from the form
	                    ctrl.timeFromUrlParamWasSelected = true;
	                }
                } catch(err) {
                	updateCalendar();
                    uiUnBlock();
                    throw "Exception @home.js - GetAllAppointmentsOfPractitioner()";
                } finally {
                	uiUnBlock();
                }
            }, function (error) {
            	updateCalendar();
                uiUnBlock();
            });
        }
        
        function loadAllAppointmentsOfPractitioner(practiceParam, practitionerIdsArray, startDate, endDate, callback) {
        	var practitionerIds = practitionerIdsArray.toString();
        	var missingPractitionerIds = practitionerIds.split(',').filter(function(id) { return ctrl.freeTimesPerPractitioner[id] == undefined; }).join(',');
        	
        	if (missingPractitionerIds === "") {
                var freeTimesOfPractitioners = practitionerIds.split(',').reduce(function(collection, id) {
            		return collection.concat(ctrl.freeTimesPerPractitioner[id]);
            	}, []);
                callback(freeTimesOfPractitioners);
                return;
        	}
        	
        	appointmentService.getAllAppointmentsOfPractitioner(practiceParam, missingPractitionerIds, startDate, endDate).then(function (res) {
        	    missingPractitionerIds.split(',').forEach(function(id) { ctrl.freeTimesPerPractitioner[id] = []; });
        		
                var result = res.data;
                result.forEach(function(freeTimeSlot) {
                	freeTimeSlot.practitionerIds.forEach(function(id) {
                		ctrl.freeTimesPerPractitioner[id].push(freeTimeSlot);
                	});
                });
                
                var freeTimesOfPractitioners = practitionerIds.split(',').reduce(function(collection, id) {
                		return collection.concat(ctrl.freeTimesPerPractitioner[id]);
                	}, []);
                callback(freeTimesOfPractitioners);

        	}, function (error) {
            	console.log(error);
            });
        }

        function GetAllAppointmentsOfTreatments() {
        	var startDate = moment.utc().lang(ctrl.currentSelectedLanguage).format("YYYY-MM-DD");
        	var endDate = moment.utc(ctrl.days[ctrl.days.length - 1], "MM/DD/YYYY", ctrl.currentSelectedLanguage).add(3, 'months').format("YYYY-MM-DD");
        	
        	var allPractitionersIds = ctrl.AllPractioners.map(function (practitioner) { return practitioner.id; });
        	
        	loadAllAppointmentsOfPractitioner(ctrl.data, allPractitionersIds, startDate, endDate, function (result) { // first initialize ctrl.freeTimesPerPractitioner

        	    scrollPageAtALateStage();
        	    
	    		ctrl.AllServices.forEach(function(service) { // then update the state of the treatments
	                var practitionarIDs = service.practitionerIds;
	                loadAllAppointmentsOfPractitioner(ctrl.data, practitionarIDs, startDate, endDate, function (timeSlots) {
	                    // FIXME [dom] it might be, that the duration of the slot itself is less than service.duration. Code needs to account for that case: && moment(slot.startTime).isSameOrBefore(startMoment) ?
	                    var startMoment = getEarliestBookingTime();
	                    if (timeSlots.some(function(slot) { return moment(slot.endTime).isSameOrAfter(startMoment.add(service.duration, 'm')); })) {
	                        service.noTimeSlotsAvailable = false;
	                    } else {
	                        service.noTimeSlotsAvailable = true;
	                    }
	                
	                }, function (error) {
	                    service.noTimeSlotsAvailable = false;
	                });
	            
	            });
        	});
        }
        
        /*
         * we want to scroll the page at a very late stage, when as much as possible of the angular content has been rendered (jquery is not aware of the angular-lifecycle), so we call this funtion at a late freeTimes-getting
         */
        function scrollPageAtALateStage() {
            var alreadyScrolling = (ctrl.isMobile === true && $stateParams.practitionerId);
            if ($stateParams.scroll && !alreadyScrolling) {
                smoothScrollToSelector('#' + $stateParams.scroll);
            }
        }

        function checkThisWeek() {
            if (ctrl.days.length != 0) {
                if (moment.utc(ctrl.days[0]).lang(ctrl.currentSelectedLanguage).format("MM/DD/YYYY") != moment.utc().lang(ctrl.currentSelectedLanguage).format("MM/DD/YYYY")) {
                    return true;
                }
                else
                    return false;
            }
        }
        setWeekDays(true);
        updateCalendar();

    }

    homeController.$inject = ['dentistService', 'appointmentService', '$location', '$translate', '$state', '$scope', '$timeout', '$filter', '$stateParams', '$rootScope'];

})(window.angular);
